var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.443 18.138V5.47492C30.443 3.73374 29.0184 2.30914 27.2772 2.30914H5.11676C3.37559 2.30914 1.95099 3.73374 1.95099 5.47492V18.138C1.95099 19.8792 3.37559 21.3038 5.11676 21.3038H27.2772C29.0184 21.3038 30.443 19.8792 30.443 18.138ZM16.197 16.5551C13.5694 16.5551 11.4483 14.4341 11.4483 11.8065C11.4483 9.17888 13.5694 7.05781 16.197 7.05781C18.8246 7.05781 20.9456 9.17888 20.9456 11.8065C20.9456 14.4341 18.8246 16.5551 16.197 16.5551ZM36.7745 7.05781V24.4696C36.7745 26.2108 35.3499 27.6353 33.6087 27.6353H6.69965V24.4696H33.6087V7.05781H36.7745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayments);
export default __webpack_public_path__ + "static/media/icon_payments.be756f9d148005631c62e5fe318499bb.svg";
export { ForwardRef as ReactComponent };